export interface LineStatusToneResult {
  readonly tone: 'good' | 'advisory' | 'closure'
  /**
   * i18n key (`station-page` ns) for the two fixed labels; TfL's own
   * `statusSeverityDescription` passes through as `rawLabel` untranslated
   * (TfL vocabulary, English-only upstream).
   */
  readonly labelKey?: string
  readonly rawLabel?: string
}

/**
 * TfL `statusSeverity` levels that block travel on the line — closed /
 * suspended / severe — vs. degraded-but-running (Minor Delays, Reduced
 * Service, …). TfL's own vocabulary; 10 is Good Service.
 */
const BLOCKING_SEVERITIES = new Set([0, 1, 2, 3, 4, 5, 6, 11, 16, 20])

/**
 * "Other lines" row tone (Figma 8597:41539 shows only Good service —
 * green; the disrupted tones reuse the agreed Service-fact minimal
 * set). The label is TfL's own `statusSeverityDescription`, so the row
 * reads exactly what TfL reports; absent data reads Good service —
 * same fail-safe default as the Service fact.
 */
export function lineStatusTone(
  severity: number | undefined,
  description: string | undefined,
): LineStatusToneResult {
  if (severity === undefined || severity === 10)
    return { tone: 'good', labelKey: 'line_status_good' }
  const tone = BLOCKING_SEVERITIES.has(severity) ? 'closure' : 'advisory'
  if (description !== undefined && description !== '') return { tone, rawLabel: description }
  return { tone, labelKey: 'line_status_disruption' }
}
